export const TIPOS_OBSERVACION = {
  GENERALES: 'observacionesGenerales',
  ARMERIA: 'observacionesAdicionalesA',
  ACADEMIA: 'observacionesAdicionalesB',
  MEDICO: 'observacionesMedicas',
}

export const TIPOS_OBSERVACION_LABELS = {
  [TIPOS_OBSERVACION.GENERALES]: 'Generales',
  [TIPOS_OBSERVACION.ARMERIA]: 'Armería',
  [TIPOS_OBSERVACION.ACADEMIA]: 'Academia',
  [TIPOS_OBSERVACION.MEDICO]: 'Médico',
}
